import React from "react";
import { Route, Routes } from "react-router";
import AllOeders from "../containers/warehouse/orders";
import RtoReturns from "../containers/warehouse/rto_returns";

const wareHouseRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/warehouse/orders" element={<AllOeders />} />
        <Route path="/warehouse/returns" element={<RtoReturns />} />
      </Routes>
    </div>
  );
};

export default wareHouseRoutes;
